import axios from 'common/requester';
import { LINB_API } from 'common/constants/api-urls';
import _ from 'lodash';

export const formatStatusesFromDynamoDB = (statuses = []) => {
  return statuses.map(item => {
    const { extra } = item;
    return {
      id: item.entity_id || '',
      name: item.value || '',
      self: extra?.issueStateUrl || '',
      description: extra?.description || '',
      iconUrl: extra?.iconUrl || '',
      scope: extra?.scope || {},
      statusCategory: extra?.statusCategory || {},
      untranslatedName: item.untranslatedName || ''
    };
  });
};

export const fetchStatusesFromDynamoDB = async ({
  searchQuery = '',
  fetchAll = false
}) => {
  const MAX_LIMITATION = 1000;
  const qsParams = {
    keyword: searchQuery,
    ...(fetchAll ? { limit: MAX_LIMITATION } : {})
  };
  const data = await axios.get(
    `${LINB_API.PM_SERVICE.PM_ENTITIES.STATUSES}?${new URLSearchParams(
      qsParams
    )}`
  );
  const formattedStatuses = formatStatusesFromDynamoDB(data?.items);
  return formattedStatuses;
};

export const onSearchUI = ({ searchValue, itemsList, titleKey }) => {
  const filtered = itemsList.filter(({ [titleKey]: titleValue }) =>
    titleValue.toLowerCase().includes(searchValue.toLowerCase())
  );
  return filtered;
};

export const onSearchPMEntities = async ({ searchValue } = {}) => {
  const data = await fetchStatusesFromDynamoDB({ searchQuery: searchValue });
  // here we are deduplicationing statuses with same name and category
  const uniqueItems = _.uniqBy(data, item => {
    return [item.name, item.statusCategory?.name].join();
  });
  return uniqueItems;
};

export const deduplicateStatuses = (statuses = []) => {
  return _.uniqBy(statuses, item =>
    [item.name, item.statusCategory.name].join()
  );
};
